import React, { createContext, useContext, useState, ReactNode } from 'react';

interface NavigationContextType {
    fromPage: boolean;
    setFromPage: (value: boolean) => void;
}

const NavigationContext = createContext<NavigationContextType | undefined>(undefined);

export const NavigationProvider = ({ children }: { children: ReactNode }) => {
    const [fromPage, setFromPage] = useState<boolean>(false);

    return (
        <NavigationContext.Provider value={{ fromPage, setFromPage }}>
            {children}
        </NavigationContext.Provider>
    );
};

export const useNavigationContext = (): NavigationContextType => {
    const context = useContext(NavigationContext);
    if (!context) {
        throw new Error("useNavigationContext must be used within a NavigationProvider");
    }
    return context;
};
